import { PageHeader } from '@ant-design/pro-layout';
import React, { useState, useEffect } from 'react';
import { StaffCaseSearchContainerCaseSearchResultFieldsFragment } from '../../../../generated';
import { CaseSearchFilterContainer } from '../components/case-search-filter.container';
import CaseSearchContainer from '../components/case-search.container';
import FilterMenuToggle from '../../../shared/filter-menu-toggle';
import { SubPageLayout } from '../sub-page-layout';
import { Typography } from 'antd';

interface CaseSearchProps {}

export const CaseSearch: React.FC<CaseSearchProps> = () => {
  const [filterDataCount, setFilterDataCount] = React.useState<StaffCaseSearchContainerCaseSearchResultFieldsFragment>({});
  const [isMobile, setIsMobile] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [refreshQuery, setRefreshQuery] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <SubPageLayout header={<PageHeader title={<Typography.Title className="staff-title">Case Search</Typography.Title>} />}>
      {isMobile && <FilterMenuToggle isOpen={filterMenuOpen} onToggle={() => setFilterMenuOpen(!filterMenuOpen)} />}
      <div className={`flex flex-col text-left ${isMobile ? 'px-0' : 'px-5'}`}>
        <div className={`flex ${isMobile ? 'flex-col' : 'flex-row'} overflow-x-auto gap-5 whitespace-nowrap mt-5`}>
          {(filterMenuOpen || !isMobile) && <CaseSearchFilterContainer filterDataCount={filterDataCount} setRefreshQuery={setRefreshQuery} />}
          <CaseSearchContainer isMobile={isMobile} setFilterDataCount={setFilterDataCount} refreshQuery={refreshQuery} setRefreshQuery={setRefreshQuery} />
        </div>
        {/* <DateInformationFooter /> */}
      </div>
    </SubPageLayout>
  );
};
